var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "margin-top" },
        [
          _c("el-col", [
            _vm.localizacoes && _vm.localizacoes.length
              ? _c(
                  "div",
                  [
                    _c("app-resumo-mapa", {
                      key: _vm.mapaKey,
                      attrs: {
                        idMapa: "appResumo" + _vm.cadastroGleba.nome,
                        localizacoes: _vm.localizacoes,
                        isVisualizarCadastro: true,
                        height: 55
                      }
                    })
                  ],
                  1
                )
              : _c("div", [
                  _c("span", [
                    _vm._v("Não foi informado nenhum dado durante o cadastro.")
                  ])
                ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-770dafba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-770dafba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/bancoDados/components/InformacoesGeo.vue
// module id = null
// module chunks = 